import Article1 from './Articles/Article1.js'
import Article2 from './Articles/Article2.js'
import Article3 from './Articles/Article3.js'
import Article4 from './Articles/Article4.js'
import Article5 from './Articles/Article5.js'
import Article6 from './Articles/Article6.js'
import Article7 from './Articles/Article7.js'
import Article8 from './Articles/Article8.js'
import Article9 from './Articles/Article9.js'

class Lesson {
  constructor(id, name, set, article) {
    this.id = id
    this.name = name
    this.set = set
    this.form = 0
    this.article = article
    this.done = false
  }
  allFormsDone() {
    return this.form >= 4
  }
  incrementForm() {
    if (this.form < 4) {
      this.form++
    }
  }
}

const lessons = [
  new Lesson(1, "Long Vowels", 1, Article1),
  new Lesson(2, "ba, ta, tha", 2, Article2),
  new Lesson(3, "him, Ha, kha", 3, Article3),
  new Lesson(4, "dal, dhal, ra", 4, Article4),
  new Lesson(5, "zayn, sin, shin", 5, Article5),
  new Lesson(6, "sad, dad, ta2, za", 6, Article6),
  new Lesson(7, "ayn, ghayn, fa, qaf", 7, Article7),
  new Lesson(8, "kaf, lam, mim, nun, ha", 8, Article8),
  new Lesson(9, "Everything", null, Article9)
]

class LessonHandler {
  constructor() {
    this.lessons = lessons
  }
  getLessons() {
    return this.lessons
  }
}

export default LessonHandler
